export default __webpack_public_path__ + "static/media/Free_Play_Icon.da8a440d.png";